import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useCreateSchoolDivisonMutation, useGetSchoolDivisonDataQuery, useUpdateSchoolDivisonMutation } from "store/services/schoolsDivisons";
import useAutoUpdateInitialValues from "hooks/useAutoUpdateInitialValues";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import LoadingButton from "components/shared/LoadingButton";
import { SCHOOL_DIVISON_LIST } from "config/paths";
import schoolDivisonFormSchema from "./SchoolDivison.schema";
import { successMessageToast } from "helpers/common";
import { RequiredFieldAstrick } from "components/Common/Common";

const AddSchoolDivision = () => {
  const { id: divisonId } = useParams();
  const editMode = !!divisonId;
  const navigate = useNavigate();

  const { data: schoolDivisonData, isLoading: getSchDivisonLoading, isError: getSchDivisonError } = useGetSchoolDivisonDataQuery(divisonId, { skip: !divisonId });
  const [createSchoolDivison, { isLoading }] = useCreateSchoolDivisonMutation();
  const [updateSchoolDivison, { isLoading: updateSchDivisonLoading }] = useUpdateSchoolDivisonMutation();

  const [initialValues, setInitialValues] = useAutoUpdateInitialValues(defaultInitialValues, [schoolDivisonData]);

  const handleClickCancel = () => {
    navigate(SCHOOL_DIVISON_LIST);
  }

  const handleSubmit = async (values) => {
    try {
      let result;
      if (editMode) {
        result = await updateSchoolDivison({
          id: divisonId,
          payload: values
        });
      } else {
        result = await createSchoolDivison(values);
      }
      if (result.error) {
        console.error("Error creating discipline", result.error);
      } else {
        successMessageToast(result.data?.message || "Discipline created successfully");
        navigate(SCHOOL_DIVISON_LIST);
      }
    } catch (err) {
      console.log("Error creating discipline", err);
    }
  }

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3 d-flex align-items-center">
                <Link
                  className="themeBlue fw-sbold back-to-btn"
                  to="/manage-schools/school-division/"
                >
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                  </svg> Back
                </Link>
                <h6 className="m-0 fw-bold themeBlue">
                  Add New School Division
                </h6>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              {getSchDivisonLoading ? (
                <LoadingIndicator />
              ) : getSchDivisonError ? (
                <ErrorComponent />
              ) : (
                <Formik
                  initialValues={initialValues}
                  validationSchema={schoolDivisonFormSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({
                    handleSubmit
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div
                        className="py-3"
                        style={{ borderTop: "1px solid #41a2a84d" }}
                      >
                        <Row>
                          <Col md="4" sm="6" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0 d-flex"
                            >
                              School Division Name
                              <RequiredFieldAstrick />
                            </label>
                            <AppInputField
                              name="title"
                              placeholder="Enter Division Name"
                              className={`${styles.formControl} form-control`}
                            />
                          </Col>
                        </Row>
                      </div>
                      <Row className="mt-4">
                        <Col className="my-2" lg="12">
                          <div
                            className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                            style={{ borderTop: "1px solid #41a2a84d" }}
                          >
                            <LoadingButton
                              type="submit"
                              className="d-flex align-items-center justify-content-center commonBtn"
                              isLoading={isLoading || updateSchDivisonLoading}
                            >
                              Save
                            </LoadingButton>
                            <Button
                              onClick={handleClickCancel}
                              className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

const defaultInitialValues = {
  title: "",
  status: "active"
}

export default AddSchoolDivision;